import React, { useState } from 'react';
import { Button, Divider, Select } from 'antd';
import './MultiSelect.scss';

const FOOTER_OPTION_VALUE = '__multi_select_footer__';

function MultiSelect({
  children,
  filterOption,
  onChange,
  onReset,
  onSelect,
  mode = 'multiple',
  doneText = 'Done',
  resetText = 'Reset',
  dropdownClassName,
  open: controlledOpen,
  onDropdownVisibleChange,
  ...props
}) {
  const [open, setOpen] = useState(false);
  const isOpen = controlledOpen !== undefined ? controlledOpen : open;

  const setOpenState = (nextOpen) => {
    if (controlledOpen === undefined) {
      setOpen(nextOpen);
    }
    if (onDropdownVisibleChange) {
      onDropdownVisibleChange(nextOpen);
    }
  };

  const resetSelection = () => {
    if (onReset) {
      onReset();
      return;
    }
    if (onChange) onChange([]);
  };

  const handleChange = (values) => {
    const nextValues = (values || []).filter((value) => value !== FOOTER_OPTION_VALUE);
    if (onChange) onChange(nextValues);
  };

  const handleSelect = (value, option) => {
    if (value === FOOTER_OPTION_VALUE) return;
    if (onSelect) onSelect(value, option);
  };

  const combinedFilterOption =
    filterOption === false
      ? false
      : (input, option) => {
          if (option.props.value === FOOTER_OPTION_VALUE) return false;
          if (typeof filterOption === 'function') return filterOption(input, option);
          const label = option.props.children;
          if (typeof label !== 'string') return true;
          return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        };

  return (
    <Select
      {...props}
      mode={mode}
      open={isOpen}
      onDropdownVisibleChange={setOpenState}
      onChange={handleChange}
      onSelect={handleSelect}
      filterOption={combinedFilterOption}
      dropdownClassName={['multi-select-dropdown', dropdownClassName].filter(Boolean).join(' ')}
    >
      {children}
      <Select.Option
        key={FOOTER_OPTION_VALUE}
        value={FOOTER_OPTION_VALUE}
        disabled
        className="multi-select-dropdown__footer-option"
      >
        <Divider className="multi-select-dropdown__divider" />
        <div className="multi-select-dropdown__actions">
          <Button size="small" onMouseDown={(event) => event.preventDefault()} onClick={resetSelection}>
            {resetText}
          </Button>
          <Button
            size="small"
            type="primary"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => setOpenState(false)}
          >
            {doneText}
          </Button>
        </div>
      </Select.Option>
    </Select>
  );
}

export default MultiSelect;
